/* eslint-disable react-hooks/exhaustive-deps */ 
import { useEffect, useRef, useState } from "react" 
import { useSyncState } from "src/modules/pe-basic-module/hooks/useSyncState"
import { defaultTimelineDots, ILanding, ILandingFloat, ILandingSection, ITimelineDot, LANDING_EDIT_MODE, SECTION_DESIGN_TYPE, SELECT_CURSOR, SELECT_TYPE } from "src/modules/pe-landing-module/data/interfaces"
import { IHoverElement, ILandingConsoleStore, ILandingStore, useLandingConsoleStore, useLandingStore } from "src/modules/pe-landing-module/data/store" 
import { DataContentEditForm } from "./editors/data-content-editor" 
import setHoverData from "./utils/setHoverData"
import { getLandingContainer } from "../../utils/getLandingContainer"
import TitleEditForm from "./editors/title-ditor/TitleEditForm"
import ContentHoverMarginForm from "./ContentHoverMarginForm"
import DelimiterEditForm from "./editors/DelimiterEditForm"
import SectionTabEditForm from "./editors/SectionTabEditForm"
import AddMeatAfter from "./editors/data-content-editor/AddMeatAfter"
import AddMeatBefore from "./editors/data-content-editor/AddMeatBefore"
import SectionGalleryEditForm from "./editors/SectionGalleryEditForm"
import SectionAccordeonEditForm from "./editors/SectionAccordeonEditForm"
import SectionHAccordeonEditForm from "./editors/SectionHAccordeonEditForm"
import VerticalTimeLineEditForm from "./editors/VerticalTimeLineEditForm"
import VerticalTimelineAmplitudeHandler from "./editors/VerticalTimelineAmplitudeHandler"
import FloatEditForm from "./editors/FloatEditForm"
import Transformer, { ISelectedData } from "./transformer/Transformer"

/* Protopia Ecosystem component */
export interface IContentHoverFormProps {
   
}
const ContentHoverForm = (props: IContentHoverFormProps): JSX.Element => {
    let timeout: any  = 1
    const ref = useRef(null)
    const doubleClickType                           = useLandingStore((state: ILandingStore) => state.doubleClickType)
    const editMode                                  = useLandingConsoleStore((state:ILandingConsoleStore) => state.editMode)
    const currentLanding:ILanding                   = useLandingStore((state: ILandingStore) => state.currentLanding) 
    const selectedMeat                              = useLandingStore((state:ILandingStore) => state.selectedMeat )
    const hoverElement: IHoverElement | undefined   = useLandingStore((state:ILandingStore) => state.hoverElement )

    const [landing , setLanding]                    = useState<Element>( document.body )     
    const section                                   = useSyncState<ILandingSection | undefined>( undefined )  
    
    const move = ( event: any ) => {
        let hl: IHoverElement | undefined; 
        clearTimeout( timeout )
        if( !selectedMeat ) {
            const clickType = event.target.closest("[data-select-type]") 
            if(clickType?.getAttribute("data-select-type") === "ignore") {
                return null
            }
            const meatSelector =  [
                ".is-edit .landing-data-components-container > .landing-section-data-animation > .landing-section-data-position > .landing-content-container:hover:not(:has(.icon-square-))",
                ".is-edit .landing-data-components-container > .gallery > .swiper .swiper-wrapper > .swiper-slide > .gallery-item > .landing-section-data-animation > .landing-section-data-position > .landing-content-container:hover:not(:has(.icon-square-))"
            ]
            const curs                      = landing.querySelectorAll( meatSelector.join(",")) 
            const myself                    = landing.querySelector(".landing-hover-form")
            const curTitle                  = landing.querySelector(".landing-section-title-container > .title-animation-container > .title-position-container:hover")
            const curDelimiter              = landing.querySelector(".landing-delimiter.landing-edit-cont:hover")
            const sectionEdit               = landing.querySelectorAll(".landing-section-edit-form") 
            const curSectionTabs            = landing.querySelector(`.landing-section-horizontal-tabs:has(.bp5-tab-list.bp5-large:hover)`)
            const curSectionVerticalTabs    = landing.querySelector(`.landing-section-vertical-tabs .bp5-tab-list.bp5-large:hover`)  
            const curSectionGallery         = landing.querySelector(`.landing-section-gallery:hover`) 
            const curSectionAccordeon       = landing.querySelector(`.landing-section-accordeon:hover`) 
            const curSectionHAccordeon      = landing.querySelector(`.landing-section-haccordeon:hover`) 
            //карточки. Вертикальный таймлайн 
            const verticalTimeline          = landing.querySelector(`.pe-cards-container > div >.landing-v-timeline-timiline-container:hover`) 
            // секция. Вертикальный таймлайн
            const sectionVerticalTimeline   = landing.querySelector(`.landing-data-components-container > div > .landing-v-timeline-timiline-container:hover`)             
            // секция. Горизонтальный таймлайн
            const sectionHorizontalTimeline   = landing.querySelector(`.landing-data-components-container > div > div > .landing-h-timeline:hover`) 
            // единичное содержимое секции 
            const meat                      =  curs[0] // curs[curs.length - 1]
            // float 
            const float         = landing.querySelector(".is-edit .landing-float-container [data-content-id][data-is-canvas='false']:hover") 
            // console.log( curs ) 
            
            if(!!curTitle) {   
                sectionEdit.forEach((s: any) => {  s.style.display = "none" }) 
                hl = setHoverData( curTitle, SELECT_TYPE.TITLE ) 
            }
            else if(!!curDelimiter) {   
                sectionEdit.forEach((s: any) => {  s.style.display = "none" }) 
                hl = setHoverData( curDelimiter, SELECT_TYPE.DELIMITER ) 
            }
            else if(!!curSectionTabs) {   
                sectionEdit.forEach((s: any) => {  s.style.display = "none" }) 
                hl = setHoverData( curSectionTabs, SELECT_TYPE.HORIZONTAL_TAB, SELECT_CURSOR.SECTION ) 
            }
            else if(!!curSectionVerticalTabs) {   
                sectionEdit.forEach((s: any) => {  s.style.display = "none" }) 
                hl = setHoverData( curSectionVerticalTabs, SELECT_TYPE.VERTICAL_TAB, SELECT_CURSOR.SECTION ) 
            }
            else if(!!curSectionGallery) {   
                sectionEdit.forEach((s: any) => {  s.style.display = "none" }) 
                hl = setHoverData( curSectionGallery, SELECT_TYPE.GALLERY, SELECT_CURSOR.SECTION ) 
            }
            else if(!!curSectionAccordeon) {   
                sectionEdit.forEach((s: any) => {  s.style.display = "none" }) 
                hl = setHoverData( curSectionAccordeon, SELECT_TYPE.ACCORDEON, SELECT_CURSOR.SECTION ) 
            }
            else if(!!curSectionHAccordeon) {   
                sectionEdit.forEach((s: any) => {  s.style.display = "none" }) 
                hl = setHoverData( curSectionHAccordeon, SELECT_TYPE.HACCORDEON, SELECT_CURSOR.SECTION ) 
            }
            else if(!!sectionVerticalTimeline) {   
                sectionEdit.forEach((s: any) => {  s.style.display = "none" }) 
                hl = setHoverData( sectionVerticalTimeline, SELECT_TYPE.VERTICAL_TIMELINE, SELECT_CURSOR.SECTION ) 
            }
            else if(!!verticalTimeline) {   
                sectionEdit.forEach((s: any) => {  s.style.display = "none" }) 
                hl = setHoverData( verticalTimeline, SELECT_TYPE.VERTICAL_TIMELINE, SELECT_CURSOR.CARDS ) 
            }
            else if(!!sectionHorizontalTimeline) {   
                sectionEdit.forEach((s: any) => {  s.style.display = "none" }) 
                hl = setHoverData( sectionHorizontalTimeline, SELECT_TYPE.SECTION_TIMELINE, SELECT_CURSOR.SECTION ) 
            }
            else if(!!float) {   
                sectionEdit.forEach((s: any) => {  s.style.display = "none" }) 
                hl = setHoverData( float, SELECT_TYPE.FLOAT ) 
            }
            else if(!!meat ) { 
                sectionEdit.forEach((s: any) => {  s.style.display = "none" }) 
                hl = setHoverData( meat, SELECT_TYPE.CONTENT )  
            }
            else if( !!myself && myself.matches(':hover') ) { 
                // console.log("myself hover") 
            }
            else { 
                sectionEdit.forEach((s: any) => s.style.display = "inherit")
                //sectionId.set( "" )
                hl = removeSelect() 
            } 
            
        }
        else if( !!selectedMeat ) {
            
            console.log( selectedMeat )
            
            hl = removeSelect() 
        }
        if(hl) {
            section.set( currentLanding.sections.find( (section) => section.id === hl?.sectionId ) )
        }
        else {
             
        }
        
    } 

    const removeSelect = () : undefined => {
        // setHoverData()
        timeout = setTimeout( () => setHoverData(  ), 700 )
    }
    useEffect(() => { 
        const landing: Element = getLandingContainer()
        setLanding( landing ) 
        landing.addEventListener( "mousemove", move )
        landing.addEventListener( "scroll", move ) 
        return () => {
            landing.removeEventListener( "mousemove", move )
            landing.removeEventListener( "scroll", move )
            
            // reset click-selected object
            Transformer.setSelected( {} as ISelectedData )
        }
    }, []) //  
    
    if( doubleClickType !== SELECT_TYPE.NONE || editMode !== LANDING_EDIT_MODE.EDIT ) {
    // if( editMode !== LANDING_EDIT_MODE.EDIT ) {
        return <></>
    }

    const isHorizontal: boolean = [
        SECTION_DESIGN_TYPE.CAROUSEL, 
        SECTION_DESIGN_TYPE.HTIMELINE, 
        SECTION_DESIGN_TYPE.COLUMN,  
        SECTION_DESIGN_TYPE.TABS,
    ].includes( section.get()?.designType || SECTION_DESIGN_TYPE.FEED )

    const getBound = (): Partial<DOMRect> => { 
        return {
            top:  hoverElement?.bound.top|| 0, 
            left: hoverElement?.bound.left || 0, 
            width: hoverElement?.bound.width || 100
        }
    } 
    return <>
    {/* <div  
        style={{
            width: "100vw",
            height: "100vh",
            top:0,
            left:0,
            background: "#FF000022",
            position: "fixed",
            pointerEvents: "none",  
        }} 
    >
        <div className="position-absolute top left m-4 p-5 lead bg-danger text-light">
            {
                JSON.stringify( hoverElement?.bound )
            }
            <div className="mt-5">
                { JSON.stringify(!!section.get())}
            </div>
        </div>
    </div> */}
    <div 
        className='landing-hover-form '
        style={ getBound() } 
        ref={ref}
    >
        <div 
            className="current-hover" 
            style={{
                width: hoverElement?.bound.width,
                height: hoverElement?.bound.height
            }} 
        >
            <div className="current-dimentions text-nowrap">
                {
                    !!hoverElement?.id && <span className="mr-2 title text-nowrap d-none">
                        #{ hoverElement?.id }
                    </span>
                } 
                <span className="text-nowrap ">
                    { hoverElement?.bound.width?.toFixed(1) } X { hoverElement?.bound.height?.toFixed(1) }
                </span>
                
            </div>
            
        </div> 
        <ContentHoverMarginForm />
        {
            hoverElement?.selectType === SELECT_TYPE.CONTENT &&
            <>
                <DataContentEditForm 
                    section={ section.get() } 
                    data={ section.get()?.data.find(data => data.id === hoverElement.id ) || {} } 
                />               
                {
                    false &&
                        <AddMeatBefore
                        height={ ( hoverElement?.bound.height || 0 ) }
                        width={ ( hoverElement?.bound.width || 0 ) }
                        section={ section.get() } 
                        data={ section.get()?.data.find(data => data.id === hoverElement?.id ) } 
                        isHorizontal={isHorizontal}
                    />
                }
                <AddMeatAfter
                    height={ ( hoverElement?.bound.height || 0 ) }
                    width={ ( hoverElement?.bound.width || 0 ) }
                    section={ section.get() } 
                    data={ section.get()?.data.find(data => data.id === hoverElement.id ) }
                    isHorizontal={isHorizontal} 
                />
            </>
        } 
        {
            hoverElement?.selectType === SELECT_TYPE.TITLE &&
                <TitleEditForm 
                    section={ section.get() || {} as ILandingSection }
                />
        } 
        {
            hoverElement?.selectType === SELECT_TYPE.DELIMITER &&
                <DelimiterEditForm 
                    section={ section.get() || {} as ILandingSection }
                /> 
        } 
        {
            (hoverElement?.selectType === SELECT_TYPE.HORIZONTAL_TAB || hoverElement?.selectType === SELECT_TYPE.VERTICAL_TAB ) &&
                <SectionTabEditForm 
                    section={ section.get() || {} as ILandingSection }
                />
        } 
        {
            hoverElement?.selectType === SELECT_TYPE.GALLERY &&
                <SectionGalleryEditForm 
                    section={ section.get() || {} as ILandingSection }
                />
        } 
        {
            hoverElement?.selectType === SELECT_TYPE.ACCORDEON &&
                <SectionAccordeonEditForm 
                    section={ section.get() || {} as ILandingSection }
                />
        } 
        {
            hoverElement?.selectType === SELECT_TYPE.HACCORDEON &&
                <SectionHAccordeonEditForm 
                    section={ section.get() || {} as ILandingSection }
                />
        } 
        {
            hoverElement?.selectType === SELECT_TYPE.SECTION_TIMELINE &&
                <VerticalTimeLineEditForm 
                    section={ section.get() || {} as ILandingSection }
                    cursor={hoverElement.cursor as SELECT_CURSOR || SELECT_CURSOR.SECTION}
                />
        } 
        {
            hoverElement?.selectType === SELECT_TYPE.VERTICAL_TIMELINE &&  
            <>
                <VerticalTimeLineEditForm 
                    section={ section.get() || {} as ILandingSection }
                    cursor={hoverElement.cursor as SELECT_CURSOR || SELECT_CURSOR.SECTION}
                />
                <VerticalTimelineAmplitudeHandler 
                    dots={ section.get()?.dots || defaultTimelineDots() } 
                    cursor={hoverElement.cursor as SELECT_CURSOR || SELECT_CURSOR.SECTION}
                />
            </>
        } 
        {
            hoverElement?.selectType === SELECT_TYPE.FLOAT &&
                <FloatEditForm 
                    section={ section.get() || {} as ILandingSection }
                    float={  section.get()?.floats.find(data => data.id === hoverElement.id ) || {} as ILandingFloat  }
                />
        } 
    </div></>
}
export default ContentHoverForm